import { render, staticRenderFns } from "./EMelderComponentMeldungenCommunication.vue?vue&type=template&id=6fabdcfa&scoped=true"
import script from "./EMelderComponentMeldungenCommunication.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldungenCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fabdcfa",
  null
  
)

export default component.exports